export const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

export const findDocument = (screens, id) => screens
  .flatMap((screen) => screen.documents)
  .find((document) => document.id === id) || null;
